export default {
    apiUrl:{
        //入驻管理
        settleUrl : {
            merchantList:'/merchant/merchantEnter/getMerchantQualificationList',// 列表
            settleDetali:'/merchant/merchantEnter/getMerchantQualificationListById/',
            // nopass:'merchant/merchantEnter/insertMerchantauditLog',  //基本信息审核完成
            allnopass:'/merchant/merchantEnter/updateMerchantInfoStateById', //基本信息全部通过，不通过，类目审核完成
            listMessage:'/merchant/merchantEnter/getMerchantManageInfoById/', //经营类目        
            cost:'/merchant/merchantEnter/insertPaymentPrice',  //费用缴纳
            relist:'merchant/merchantEnter/echoPaymentPrice/', //费用回显
            deResean:'/merchant/merchantEnter/selectPalmMerchantauditLogDetail/', //平台信息审核回显,
            did:'/system/district/detail/'
        },
        sellerUrl:{
        	//商家管理
           sellM:'/merchant/merchantInfo/getMerchantInfoList', //列表
           sellergrade:'/merchant/merchantGrade/selecMerchantGradeByName', //商家等级列表
           setgrade:'/merchant/merchantInfo/updateMerchantInfoByMerchantGradeId',  //等级设置
           sellerDetail:'/merchant/merchantInfo/getMerchantParticulaById/' , //商家详情
           freeze:'/merchant/merchantInfo/deleteMerchantInfoById/',  //商家冻结
           type:'/merchant/merchantInfo/getMerchantTypeList', //商户类型,
           pri:'/goods/item/addGoodsCommissionRate',
           showpri:'/goods/item/findCommissionRate' ,//佣金比例回显,
           list:'/goods/backendCategory/getMerchantListLevelBackendCategory',
           getStoreCategoryList:'/goods/category/getStoreCategoryList',//类目列表
           addGoodsCommissionRate:'/goods/category/addGoodsCommissionRate',//设置佣金比例
           listStoreBusinessEntity:"/merchant/merchantInfo/listStoreBusinessEntity",    //业务主体
            updateStoreBusinessEntity:"/merchant/merchantInfo/updateStoreBusinessEntity",   //修改业务主体

        },
        sellerGrade:{
        	//商家等级
        	gradeList:'/merchant/merchantGrade/getMerchantGradeList', //列表
        	editList:'/merchant/merchantGrade/getMerchantGradeById/',   //编辑,
            del:'/merchant/merchantGrade/deleteMerchantGradeByIds' ,  //删除
            change:'/merchant/merchantGrade/updateMerchantGradeById',   //修改
            add:'/merchant/merchantGrade/insertMerchantGradeInfo'
        },
        revise:{
            reviseList:'/merchant/storeInfo/getMerchantModifyInfo',//修改审核列表
            againActive:'/merchant/storeInfo/insertMerchantModifyInfoExmine',//审核完成
            againPass:'/merchant/storeInfo/insertExamineAdoptInfo',//审核通过,
            againInfo:'/merchant/storeInfo/getMerchantModifyInfoBymerchantId'//审核详情
        }  
    }
}